var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"wochit-go-qr",attrs:{"src":"/resources/img/wochit-go-qr.png","alt":"Scan to download Wochit Go"}})}
var staticRenderFns = []

export { render, staticRenderFns }